@import '~style-sheet-helpers/core.less';

.terms-body {
  padding: 10px;
  line-height: 1.2;
}

.logo-wrapper {
  padding-bottom: 20px;
  > img {
    width: 200px;
  }
}

.instruction-wrapper {
  padding: 20px;
  text-align: center;
}

.terms-footer {
  button {
    margin-left: 10px;
  }
}
